// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__player {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 120px;
  background: rgba(23, 21, 21, 0.3);
  z-index: 1000000;
  opacity: 0.99;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(45px);
  box-shadow: inset 0px 0px 20px 10px rgba(23, 21, 21, 0.75);
}
@media (min-width: 768px) {
  .__player {
    height: 70px;
  }
}
.__player .__player_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.__player .__player_box .__player_box_left {
  display: flex;
}
@media (max-width: 768px) {
  .__player .__player_box .__player_box_left {
    display: none;
  }
}
.__player .__player_box .__player_box_player {
  flex: 1;
}
@media (max-width: 768px) {
  .__player .__player_box .__player_box_player {
    width: 36%;
  }
}
.__player .__player_box .__player_box_right {
  display: none;
}
@media (min-width: 768px) {
  .__player .__player_box .__player_box_right {
    display: flex;
  }
}
.__player .__player_box .__player_box_right .__player_tip_icon {
  display: flex;
}
@media (max-width: 768px) {
  .__player .__player_box .__player_box_right .__player_tip_icon {
    display: none;
  }
}
.__player .__player_box_top {
  display: flex;
  justify-content: space-between;
}
@media (min-width: 768px) {
  .__player .__player_box_top {
    display: none;
  }
}
.__player .__player_box_top .__player_box_top_right {
  display: flex;
  align-items: flex-end;
}
@media (min-width: 768px) {
  .__player .__player_box_top .__player_box_top_right {
    display: none;
  }
}
.__player .__player_box_top .__player_box_top_left {
  display: none;
}
@media (max-width: 768px) {
  .__player .__player_box_top .__player_box_top_left {
    display: flex;
  }
}
.__player .__player_box_top .__player_box_top_left .__artist_name {
  overflow-x: auto;
  white-space: nowrap;
}
.__player .__player_box_top .__player_box_top_left .__artist_name::-webkit-scrollbar {
  height: 0;
}
.__player .__player_box_top .__player_box_top_left .__artist_name::-webkit-scrollbar-horizontal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/Player/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,aAAA;EACA,mCAAA;EACA,2BAAA;EACA,0DAAA;AA4BF;AA1BE;EAbF;IAcI,YAAA;EA6BF;AACF;AA3BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA6BJ;AA3BI;EACE,aAAA;AA6BN;AA3BM;EAHF;IAII,aAAA;EA8BN;AACF;AA3BI;EACE,OAAA;AA6BN;AA3BM;EAHF;IAII,UAAA;EA8BN;AACF;AA3BI;EACE,aAAA;AA6BN;AA3BM;EAHF;IAII,aAAA;EA8BN;AACF;AA5BM;EACE,aAAA;AA8BR;AA5BQ;EAHF;IAII,aAAA;EA+BR;AACF;AA1BE;EACE,aAAA;EACA,8BAAA;AA4BJ;AA1BI;EAJF;IAKI,aAAA;EA6BJ;AACF;AA3BI;EACE,aAAA;EACA,qBAAA;AA6BN;AA3BM;EAJF;IAKI,aAAA;EA8BN;AACF;AA3BI;EACE,aAAA;AA6BN;AA3BM;EAHF;IAII,aAAA;EA8BN;AACF;AA5BM;EACE,gBAAA;EACA,mBAAA;AA8BR;AA5BQ;EACE,SAAA;AA8BV;AA3BQ;EACE,aAAA;AA6BV","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__player {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 120px;\n  background: rgba(23, 21, 21, 0.3);\n  z-index: 1000000;\n  opacity: 0.99;\n  -webkit-backdrop-filter: blur(30px);\n  backdrop-filter: blur(45px);\n  box-shadow: inset 0px 0px 20px 10px rgba(23, 21, 21, 0.75);\n\n  @media (min-width: 768px) {\n    height: 70px;\n  }\n\n  .__player_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .__player_box_left {\n      display: flex;\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n    }\n\n    .__player_box_player {\n      flex: 1;\n\n      @media (max-width: 768px) {\n        width: 36%;\n      }\n    }\n\n    .__player_box_right {\n      display: none;\n\n      @media (min-width: 768px) {\n        display: flex;\n      }\n\n      .__player_tip_icon {\n        display: flex;\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .__player_box_top {\n    display: flex;\n    justify-content: space-between;\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n\n    .__player_box_top_right {\n      display: flex;\n      align-items: flex-end;\n\n      @media (min-width: 768px) {\n        display: none;\n      }\n    }\n\n    .__player_box_top_left {\n      display: none;\n\n      @media (max-width: 768px) {\n        display: flex;\n      }\n\n      .__artist_name {\n        overflow-x: auto;\n        white-space: nowrap;\n\n        &::-webkit-scrollbar {\n          height: 0;\n        }\n\n        &::-webkit-scrollbar-horizontal {\n          display: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
